import { render, staticRenderFns } from "./Gride2.vue?vue&type=template&id=3fa73037"
import script from "./Gride2.vue?vue&type=script&lang=js"
export * from "./Gride2.vue?vue&type=script&lang=js"
import style0 from "./Gride2.vue?vue&type=style&index=0&id=3fa73037&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports